import type { PostgrestSingleResponse } from "@supabase/postgrest-js";
import { useSupabaseCallback } from "../../../server/supabase/hooks";
import type { SupabaseCallback } from "../../../server/supabase/hooks/use-supabase-callback";
import { toISO8601 } from "../../../utils/iso8601";
import type { UUID } from "../../../utils/uuid";
import { type Asset, SupabaseDigitalAssetService } from "../server/digital-asset-service";

export const useDeleteAssetCallback = (): SupabaseCallback<
  [UUID],
  PostgrestSingleResponse<Asset>
> => {
  return useSupabaseCallback(async ({ supabase }, assetId: UUID) => {
    return new SupabaseDigitalAssetService(supabase).update(assetId, {
      deleted_at: toISO8601(new Date()),
    });
  }, []);
};
